export const showSizeChartDefault = (isOneSize, hasMeaningfulSize) => !isOneSize || hasMeaningfulSize;
export const showSizeChartWatches = () => true;
